import { getAnalyticsTaskAttribute as getDiagramAnalyticsTaskAttribute } from '@process-advisor/process-miner/processMiner/processMiner';

export type TaskAttributeProps = {
    attribute?: string;
}

export const getAnalyticsTaskAttribute = (): TaskAttributeProps => getDiagramAnalyticsTaskAttribute();
